var Pages;
(function (Pages) {
    Pages[Pages["TRANSACTION"] = 0] = "TRANSACTION";
    Pages[Pages["BID_HISTORY"] = 1] = "BID_HISTORY";
    Pages[Pages["DETAILS_BID"] = 2] = "DETAILS_BID";
})(Pages || (Pages = {}));
var PageTypes;
(function (PageTypes) {
    PageTypes["HOMEPAGE"] = "homepage";
    PageTypes["MARKETPLACE"] = "marketplace";
    PageTypes["TRANSPORTERS"] = "transporters";
    PageTypes["GROW_NETWORK"] = "grow-network";
    PageTypes["ONLINE_LOAD_BOOKING"] = "online-load-booking";
    PageTypes["ONLINE_TRUCK_BOOKING"] = "online-truck-booking";
    PageTypes["LOGISTICS_SERVICE"] = "logistics-service";
    PageTypes["FULL_TRUCK_LOAD"] = "full-truck-load";
    PageTypes["PART_LOAD_BOOKING"] = "part-load-booking";
    PageTypes["BUSINESS_CARDS"] = "business-cards";
    PageTypes["ABOUT_US"] = "about-us";
    PageTypes["HOW_VAHAK_HELPS"] = "how-vahak-helps";
    PageTypes["WHY_CHOOSE_US"] = "why-choose-us";
    PageTypes["CAREERS"] = "careers";
    PageTypes["CONTACT_US"] = "contact-us";
    PageTypes["MY_LOADS"] = "my-loads";
    PageTypes["MY_LORRIES"] = "my-lorries";
    PageTypes["USER_PROFILE"] = "user-profile";
})(PageTypes || (PageTypes = {}));

export { PageTypes, Pages };
//# sourceMappingURL=Pages.js.map
